import { createSlice } from "@reduxjs/toolkit";

interface loginResponseValue {
  jwtToken: string;
  groups: Array<string>;
  userTypeGroup: string;
  username: string;
  email: string;
  sub: string;
  accessToken: string;
  permissions: string;
  featurePermissions: any;
  userRole: string;
  firstName: string;
  lastName: string;
  department: string;
}
const initialState: loginResponseValue = {
  jwtToken: "",
  groups: [],
  userTypeGroup: "",
  username: "",
  email: "",
  sub: "",
  accessToken: "",
  permissions: "",
  featurePermissions: "",
  userRole: "",
  firstName: "",
  lastName: "",
  department: "",
};
export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginCognitoInfo(state, action) {
      state.jwtToken = action.payload.jwtToken;
      state.groups = action.payload.groups;
      state.userTypeGroup = action.payload.userTypeGroup;
      state.username = action.payload.username;
      state.email = action.payload.email;
      state.sub = action.payload.sub;
      state.permissions = action.payload.permissions;
      state.featurePermissions = action.payload.featurePermissions;
      state.userRole = action.payload.userRole;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.department = action.payload.department;
    },
    resetLoginState: (state) => initialState,
    updatePermission: (state, action) => {
      state.permissions = action.payload;
    },
  },
});
export const loginCognitoActions = loginSlice.actions;
export default loginSlice.reducer;
